import { InventoryType, PREORDER_INVENTORY } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'

export interface InventoryDataType {
  inventoryType: InventoryType
}

function getPreorder(shopifyVariantMetaFieldOrIsPreOrder?: InventoryDataType | boolean) {
  let isPreorder = false

  if (typeof shopifyVariantMetaFieldOrIsPreOrder === 'boolean') {
    isPreorder = shopifyVariantMetaFieldOrIsPreOrder
  } else {
    isPreorder = shopifyVariantMetaFieldOrIsPreOrder?.inventoryType === PREORDER_INVENTORY
  }

  return { showPreorder: isPreorder }
}

export default getPreorder
